// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staff-actions {
    width: 100%;
    display: flex;    
    align-items: center;
    justify-content: flex-end;

}
.staff-actions__action {
    align-self: flex-start;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-left: 30px;
    position: relative;
}
.staff-actions__action.baloa-mini{
    color: var(--basic-gray-color);
}

.staff-actions__action:hover {
    cursor: pointer;
}

.staff-actions-icon{
    font-size: 30px;    
    color: var(--primary-very-dark-color);
}

.icon-check-single-72.staff-actions-icon{
    font-size: 22px;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: var(--white-color);
    background: var(--new-green-color);
    border-radius: 50%;
    cursor: pointer;
}

.icon-x.staff-actions-icon{
    font-size: 16px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: var(--primary-dark-color);
    background: var(--new-gray-background-color);
    border-radius: 50%;
    cursor: pointer;
}

.staff-actions__action__icon-edit {
    cursor: pointer;
    width: 22px;
    height: 22px;
    margin-right: 8px;
    padding: 2px;
}

.staff-actions__action__icon-edit path {
    fill: var( --primary-very-dark-color );
}

.staff-actions__tooltip{
    visibility: hidden;
    width: 90px;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    text-align: center;
    border-radius: var(--space-and-half);
    padding: 5px 0;
    box-shadow: 0px 1px 2px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1000;
    bottom: 30px;
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
}

.tooltip__cancel-edit:hover .staff-actions__tooltip{
    visibility: visible;
}

.tooltip__check-edit:hover .staff-actions__tooltip{
    visibility: visible;
}

.tooltip__edit:hover .staff-actions__tooltip{
    visibility: visible;
}

.tooltip__delete:hover .staff-actions__tooltip{
    visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-staff-actions/StaffActionComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,yBAAyB;;AAE7B;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,uBAAuB;;IAEvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".staff-actions {\n    width: 100%;\n    display: flex;    \n    align-items: center;\n    justify-content: flex-end;\n\n}\n.staff-actions__action {\n    align-self: flex-start;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-left: 30px;\n    position: relative;\n}\n.staff-actions__action.baloa-mini{\n    color: var(--basic-gray-color);\n}\n\n.staff-actions__action:hover {\n    cursor: pointer;\n}\n\n.staff-actions-icon{\n    font-size: 30px;    \n    color: var(--primary-very-dark-color);\n}\n\n.icon-check-single-72.staff-actions-icon{\n    font-size: 22px;\n    padding: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    color: var(--white-color);\n    background: var(--new-green-color);\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.icon-x.staff-actions-icon{\n    font-size: 16px;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    color: var(--primary-dark-color);\n    background: var(--new-gray-background-color);\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.staff-actions__action__icon-edit {\n    cursor: pointer;\n    width: 22px;\n    height: 22px;\n    margin-right: 8px;\n    padding: 2px;\n}\n\n.staff-actions__action__icon-edit path {\n    fill: var( --primary-very-dark-color );\n}\n\n.staff-actions__tooltip{\n    visibility: hidden;\n    width: 90px;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    text-align: center;\n    border-radius: var(--space-and-half);\n    padding: 5px 0;\n    box-shadow: 0px 1px 2px;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1000;\n    bottom: 30px;\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n}\n\n.tooltip__cancel-edit:hover .staff-actions__tooltip{\n    visibility: visible;\n}\n\n.tooltip__check-edit:hover .staff-actions__tooltip{\n    visibility: visible;\n}\n\n.tooltip__edit:hover .staff-actions__tooltip{\n    visibility: visible;\n}\n\n.tooltip__delete:hover .staff-actions__tooltip{\n    visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
